import React from 'react';
import { IconRatingStar, Tooltip } from 'gatorcomponents';
import * as Styles from './FavoriteButton.styles';
import { useDispatch } from 'react-redux';
import { advancedHostingActions } from '@/redux/modules/advancedHosting';

const FavoriteButton = ({
  serverId,
  isFavorite,
  locale,
  onSuccess,
  size = 'sm2',
}) => {
  const dispatch = useDispatch();

  const handleUpdateFavoriteStatus = () => {
    dispatch(advancedHostingActions.updateServer.request({
      serverId,
      isFavorite: !isFavorite,
      onSuccess,
    }));
  };

  return (
    <Tooltip content={locale?.favorite} preferredPosition="bottomRight">
      <Styles.Favorite
        onClick={handleUpdateFavoriteStatus}
        data-testid={`favorite-button-${serverId}`}
        aria-label={locale?.favorite}
        $isFavorite={isFavorite}
      >
        <IconRatingStar
          size={size}
          color={isFavorite ? 'attentionMedium' : 'lowMedium'}
          filled={isFavorite}
        />
      </Styles.Favorite>
    </Tooltip>
  );
};

FavoriteButton.displayName = 'FavoriteButton';

export default FavoriteButton;
